import React, { Component } from 'react';
import Cookies from 'universal-cookie';
// import TagManager from 'react-gtm-module';
import { makeStyles } from '@material-ui/core/styles';
import {Paper,Button,CircularProgress} from '@material-ui/core';

//controllers
import Comunicado_controller from '../../../../../../controllers/comunicado';
import Contato_controller from '../../../../../../controllers/contato';
import Config from '../../../../../../controllers/config';
import Log from '../../../../../../controllers/log';

const useStyles = makeStyles(theme => ({
    root: {
      padding: theme.spacing(3, 2),
    },
    imagem: {
        maxWidth: 1000,
        maxHeight: 1000,
        width: '100%',
        height: 900
    }
}));

function goBack(props) {
    if((navigator.userAgent.toLowerCase().indexOf('firefox') > -1) && props.state.arquivo) {
        history.go(-2);
    } else {
        history.back();
    }
}

function ShowArquivos(props) {
    const classes = useStyles();

    return(
        <div className="container">
            <Button 
                variant="contained" 
                color="primary" 
                onClick={()=>{goBack(props)}}
            >
                {"Voltar"}
            </Button>
            <br/>
            <br/>
            <Paper className={classes.root} align="center">
                {props.state.isLoading &&
                    <CircularProgress/>
                }
                {!props.state.isLoading &&
                    <iframe src={props.state.conteudo} className={classes.imagem}/>
                }
            </Paper>
        </div>
    );
}

export default class Arquivos extends Component {

    constructor(props) {
        super(props);

        this.state = {
            conteudo: '',
            arquivo: false,
            isLoading: true
        }

        this.setState = this.setState.bind(this);
    }

    componentDidMount() {
        this.loadFile();

        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:arquivos',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-arquivos',
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        Log.info(token,"Efetuado carregamento da tela de arquivos!");
    }

    async loadFile() {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {

            var filename = `${this.props.route.link}.pdf`;

            //faz recuperação de nome do arquivo
            var r_arquivo = null;
            var url = null;
            if (this.props.route.link == "comunicado") {
                const filters = {
                    id: this.props.params.id
                };
                r_arquivo = await Comunicado_controller.get(token, filters);
            } else if (this.props.route.link == "contato") {
                const filters = {
                    id: this.props.params.id
                };
                r_arquivo = await Contato_controller.get(token, filters);
            }
            
            if (this.props.route.link != "pedido") {
                const j_r_arquivo = JSON.parse(r_arquivo.body);
                if (r_arquivo.res.statusCode == 200) {
                    const resp = j_r_arquivo.itens[0].diretorio;
                    if (resp != null && resp != "") {
                        const local = resp.split(";@Assets");
                        filename = local[1].split("/");
                        filename = filename[2];
                    }

                    // TagManager.dataLayer({
                    //     dataLayer: {
                    //       event: 'event',
                    //       eventCategory: 'tokstok:fornecedores:arquivos',
                    //       eventAction: 'callback',
                    //       eventLabel: `sucesso:arquivo-${filename}`,
                    //     }
                    // });
                }
            }

            if (this.props.route.link == "pedido") {
                url = `${Config.URL_BACKEND}/pedidoCompra/arquivos/${this.props.params.cd_fil}/${this.props.params.cd_pedido}/${token}/${filename}`;
            } else {
                url = `${Config.URL_BACKEND}/${this.props.route.link}/arquivos/${this.props.params.id}/${token}/${filename}`;
            }

            //seta url para arquivo
            this.setState({
                conteudo: url,
                arquivo: true,
                isLoading: false
            });

            //auditoria
            var str = "Efetuada requisição para recuperação de dados de arquivo! "
            +"Response:( Method: "+r_arquivo.res.request.method
            +", StatusCode: "+r_arquivo.res.statusCode
            +", Body: (limited 100chars)"+r_arquivo.body.substr(0,100)
            +" )";
            Log.info(token,str);
        } catch (error) {
            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:arquivos',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            var str = "Erro na recuperação de dados de arquivo! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }
        
    }

    async loadRota(rota) {
        this.setState({conteudo: rota});
    }

    render() {
        return (<ShowArquivos {...this}/>);
    }

}